import { View } from 'backbone';
import htmlTemplate from 'properties/advanced/multilanguage.ejs';
import ReactModal from '../../../components/Common/CommonModal';
import Multilingual from '../../../components/Multilingual/MultilingualContainer';
import listService from 'ListService';
import pageSyncService      from 'PageSyncService';

class MultilanguageView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'click #multilanguageManager': 'displayMultilanguageManagementModal',
            'change #language' : 'updateLanguage'
        };

        return this;
    }

    updateLanguage(ev){
        ev.preventDefault();
        let propVal  = ev.currentTarget.value;
     
        listService.currentLanguage = propVal;
        const currentPage = listService.currentPageId;

        //Rerender current page
        pageSyncService.displayPage(currentPage);
    }

    displayMultilanguageManagementModal(ev) {
        ev.preventDefault();
        ReactModal.open(Multilingual, {
            modalProps: { headerTitle: 'Language Management' }
        });
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }
}

export default MultilanguageView;
